import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import React from "react";

export default function PublishingPolicyDialog({ open, onClose }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                Publishing Policy
            </DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
                    <strong>Puzzle Publishing Guidelines:</strong>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.6 }}>
                    • <strong>Genre Rotation:</strong> Puzzles are published in genre rotation order to ensure variety and fair distribution across all categories.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.6 }}>
                    • <strong>Minimum Threshold:</strong> Each genre must have at least 3 reviewed puzzles before it becomes eligible for publishing.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.6 }}>
                    • <strong>Alternating Types:</strong> Hidden Message and Word Search puzzles are published alternately to maintain balance between puzzle types.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1.5, lineHeight: 1.6 }}>
                    • <strong>Publishing Order:</strong> Puzzles are published in order of review completion, regardless of free or premium status.
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2, fontStyle: 'italic' }}>
                    This policy ensures fair distribution, quality control, and optimal user experience across all puzzle categories.
                </Typography>
            </DialogContent>
        </Dialog>
    );
}

